export default {
  ADD_CLUSTERLET_CONNECTION: 'ADD_CLUSTERLET_CONNECTION',
  DELETE_CLUSTERLET_CONNECTION: 'DELETE_CLUSTERLET_CONNECTION',
  UPDATE_FULL_CLUSTERLET_CONNECTIONS: 'UPDATE_FULL_CLUSTERLET_CONNECTIONS',
  RESET_CLUSTERLET_CONNECTIONS: 'RESET_CLUSTERLET_CONNECTIONS',
  EDIT_CLUSTERLET_CONNECTION: 'EDIT_CLUSTERLET_CONNECTION'
};
